(function () {
  'use strict';

  var COMPARE_KEY = 'tcb_pkg_compare_list';
  var MAX_COMPARE = 4;
  var LIB_PAGE_SIZE = 18;
  var urls = window.TCB_PKG_COMPARE_URLS || {};

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s || '';
    return d.innerHTML;
  }

  function renderTierStrip(host, subtitle) {
    if (!host) return;
    if (!subtitle || subtitle.indexOf('→') === -1) {
      host.innerHTML = '';
      host.hidden = true;
      return;
    }
    var steps = subtitle.split('→').map(function (s) { return s.trim(); }).filter(Boolean);
    var tierClasses = ['starter', 'growth', 'professional', 'full-facility'];
    host.innerHTML = steps.map(function (step, i) {
      var cls = tierClasses[i] || '';
      return '<span class="tcb-ec-tier-step' + (cls ? ' tcb-ec-tier-step--' + cls : '') + '">' + esc(step) + '</span>' +
        (i < steps.length - 1 ? '<span class="tcb-ec-tier-step__arrow" aria-hidden="true">→</span>' : '');
    }).join('');
    host.hidden = false;
  }

  function markUniformTableRows(tableHost) {
    if (!tableHost) return;
    tableHost.querySelectorAll('tbody tr').forEach(function (tr) {
      var cells = tr.querySelectorAll('td');
      if (cells.length < 2) return;
      var first = cells[0].textContent.trim().toLowerCase();
      var uniform = Array.prototype.every.call(cells, function (c) {
        return c.textContent.trim().toLowerCase() === first;
      });
      tr.setAttribute('data-uniform', uniform ? '1' : '0');
    });
  }

  function bindDiffToggle(root, toggleSel, tableSel) {
    var toggle = root.querySelector(toggleSel);
    var tableHost = root.querySelector(tableSel);
    if (!toggle || !tableHost) return;
    toggle.checked = false;
    tableHost.classList.remove('is-diff-only');
    toggle.addEventListener('change', function () {
      tableHost.classList.toggle('is-diff-only', toggle.checked);
    });
  }

  function tierClassName(tier, rec) {
    if (rec && rec.badge) return String(rec.badge).toLowerCase().replace(/\s+/g, '-');
    return String(tier || 'good').toLowerCase();
  }

  function cartRoute(path) {
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return base.replace(/\/$/, '') + path;
  }

  function refreshCartUi() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('tcb:cart-updated'));
  }

  function packageRecommendation(rec, comparison, i) {
    if (rec && rec.recommendation) return rec.recommendation;
    var parts = [];
    if (rec.tierLabel) parts.push(rec.tierLabel + ' tier');
    if (rec.specs && rec.specs.facility_size) parts.push(rec.specs.facility_size);
    if (rec.specs && rec.specs.main_machine) parts.push(rec.specs.main_machine);
    if (parts.length >= 2) return 'Best for ' + parts.join(' — ') + '.';
    return (comparison.best_for && comparison.best_for[i]) || rec.bestFor || 'Commercial cleaning package';
  }

  function resolvePackageCartLines(cartItems) {
    if (!cartItems || !cartItems.length) return Promise.resolve([]);
    return Promise.all(cartItems.map(function (line) {
      return fetch('/products/' + encodeURIComponent(line.handle) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (product) {
          if (!product || !product.variants || !product.variants.length) return null;
          var variant = product.variants.find(function (v) { return v.available; }) || product.variants[0];
          if (!variant || !variant.available) return null;
          return { id: variant.id, quantity: line.quantity || 1 };
        })
        .catch(function () { return null; });
    })).then(function (lines) { return lines.filter(Boolean); });
  }

  function addPackageToCart(lines, packageTitle) {
    return fetch(cartRoute('/cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: lines.map(function (line) {
          return {
            id: line.id,
            quantity: line.quantity,
            properties: packageTitle ? { Package: packageTitle, 'Added via': 'Package Comparison' } : undefined
          };
        })
      })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw data;
        return data;
      });
    });
  }

  function bindPackageCartButton(btn, catalog) {
    if (!btn || btn.getAttribute('data-tcb-bound') === '1') return;
    btn.setAttribute('data-tcb-bound', '1');
    var defaultLabel = btn.textContent.trim();
    btn.addEventListener('click', function () {
      var handle = btn.getAttribute('data-package-handle');
      var rec = catalogRecord(catalog, handle);
      if (!rec || !rec.cart_items || !rec.cart_items.length) return;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      resolvePackageCartLines(rec.cart_items)
        .then(function (lines) {
          if (!lines.length) throw new Error('unavailable');
          return addPackageToCart(lines, rec.title);
        })
        .then(function () {
          refreshCartUi();
          btn.textContent = 'Added ✓';
          setTimeout(function () {
            btn.disabled = false;
            btn.textContent = defaultLabel;
          }, 1400);
        })
        .catch(function () {
          btn.textContent = 'Unavailable';
          setTimeout(function () {
            btn.disabled = false;
            btn.textContent = defaultLabel;
          }, 1800);
        });
    });
  }

  function imgTag(src, alt, className) {
    if (!src) return '';
    var cls = className ? ' class="' + className + '"' : '';
    return '<img src="' + esc(src) + '" alt="' + esc(alt || '') + '"' + cls + ' loading="lazy" decoding="async" onerror="this.classList.add(\'is-fallback\')">';
  }

  function comparisonHero(comparison, catalog) {
    if (comparison && comparison.hero_image) return comparison.hero_image;
    var handles = comparison.packages || [];
    var recs = catalog.packages_by_handle || {};
    for (var i = 0; i < handles.length; i++) {
      if (recs[handles[i]] && recs[handles[i]].image) return recs[handles[i]].image;
    }
    return '';
  }

  function matchesPackageFilters(comparison, filters, catalog) {
    var handles = comparison.packages || [];
    var recs = catalog.packages_by_handle || {};
    if (filters.facility) {
      var ok = handles.some(function (h) { return recs[h] && recs[h].facilityId === filters.facility; });
      if (!ok && comparison.id.indexOf(filters.facility) === -1) return false;
    }
    if (filters.tier) {
      if (!handles.some(function (h) { return recs[h] && recs[h].tier === filters.tier; })) return false;
    }
    if (filters.category && comparison.category !== filters.category && comparison.id.indexOf(filters.category) === -1) return false;
    if (filters.budget) {
      if (!handles.some(function (h) {
        var price = recs[h] && recs[h].priceMin;
        if (price == null) return filters.budget === 'over_7500';
        if (filters.budget === 'under_3000') return price < 3000;
        if (filters.budget === '3000_7500') return price >= 3000 && price <= 7500;
        if (filters.budget === 'over_7500') return price > 7500;
        return true;
      })) return false;
    }
    return true;
  }

  function priceText(rec) {
    if (!rec) return 'Request Quote';
    if (rec.priceDisplay) return rec.priceDisplay;
    if (rec.priceMin != null) return 'From $' + Number(rec.priceMin).toLocaleString();
    return 'Request Quote';
  }

  function getCompareList() {
    try { return JSON.parse(localStorage.getItem(COMPARE_KEY) || '[]'); }
    catch (_) { return []; }
  }

  function setCompareList(list) {
    localStorage.setItem(COMPARE_KEY, JSON.stringify(list.slice(0, MAX_COMPARE)));
  }

  function compareUrl(handles) {
    return '/pages/package-comparison?custom=' + handles.join(',');
  }

  function detailUrl(id) {
    return '/pages/package-comparison?compare=' + encodeURIComponent(id);
  }

  function catalogRecord(catalog, handle) {
    return (catalog.packages_by_handle && catalog.packages_by_handle[handle]) ||
      (catalog.packages_index || []).find(function (p) { return p.handle === handle; });
  }

  function fieldValue(handle, row, catalog) {
    var rec = catalogRecord(catalog, handle);
    if (!rec) return row.fallback || '—';

    switch (row.key) {
      case 'facility_type':
        return rec.specs?.facility_type || rec.facilityId || '—';
      case 'tier':
        return rec.tierLabel || rec.specs?.tier || '—';
      case 'price':
        return priceText(rec);
      case 'best_for':
        if (rec.recommendation) return rec.recommendation;
        var pParts = [];
        if (rec.tierLabel) pParts.push(rec.tierLabel + ' tier');
        if (rec.specs && rec.specs.facility_size) pParts.push(rec.specs.facility_size);
        if (rec.specs && rec.specs.main_machine) pParts.push(rec.specs.main_machine);
        if (pParts.length >= 2) return 'Best for ' + pParts.join(' — ') + '.';
        return rec.bestFor || row.fallback || 'Commercial cleaning';
      case 'included_count':
        return rec.specs?.included_count || row.fallback || 'Varies';
      default:
        if (row.key.indexOf('spec_') === 0 && rec.specs) {
          return rec.specs[row.key.slice(5)] || row.fallback || 'See package page';
        }
        return row.fallback || 'See package page';
    }
  }

  function buildRowsFromHandles(handles, catalog) {
    var specFields = catalog.spec_fields || [];
    var rows = [
      { key: 'facility_type', label: 'Facility Type' },
      { key: 'tier', label: 'Tier' },
      { key: 'price', label: 'Price' },
    ];
    specFields.forEach(function (field) {
      var has = handles.some(function (h) {
        var rec = catalogRecord(catalog, h);
        return rec && rec.specs && rec.specs[field.id];
      });
      if (has) rows.push({ key: 'spec_' + field.id, label: field.label, fallback: 'See package page' });
    });
    rows.push({ key: 'best_for', label: 'Best For', fallback: 'Commercial cleaning' });
    rows.push({ key: 'included_count', label: 'Line Items', fallback: 'Varies' });
    return rows;
  }

  function renderLibraryPagination(host, page, totalPages, onPage) {
    if (!host) return;
    if (totalPages <= 1) {
      host.hidden = true;
      host.innerHTML = '';
      return;
    }
    host.hidden = false;
    host.innerHTML =
      '<button type="button" class="tcb-ec-lib-page-btn" data-page="prev"' + (page <= 0 ? ' disabled' : '') + '>Previous</button>' +
      '<span class="tcb-ec-lib-page-status">Page ' + (page + 1) + ' of ' + totalPages + '</span>' +
      '<button type="button" class="tcb-ec-lib-page-btn" data-page="next"' + (page >= totalPages - 1 ? ' disabled' : '') + '>Next</button>';
    host.querySelectorAll('[data-page]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var dir = btn.getAttribute('data-page');
        if (dir === 'prev') onPage(page - 1);
        else if (dir === 'next') onPage(page + 1);
      });
    });
  }

  function App(root, catalog) {
    this.root = root;
    this.catalog = catalog;
    this.libView = root.querySelector('[data-tcb-pc-library]');
    this.detailView = root.querySelector('[data-tcb-pc-detail]');
    this.filters = { facility: '', tier: '', category: '' };
    this.libPage = 0;
    this.init();
  }

  App.prototype.init = function () {
    var params = new URLSearchParams(window.location.search);
    var compareId = params.get('compare');
    var custom = params.get('custom');

    this.renderCategories();
    this.renderFacilityTable();
    this.renderFacilities();
    this.renderEquipmentLink();
    this.renderRelated();
    this.renderPopularSearches();
    this.populateFilters();
    this.bindEvents();
    this.updateSticky();

    if (custom) {
      this.openCustomCompare(custom.split(',').filter(Boolean));
    } else if (compareId) {
      this.openDetail(compareId);
    } else {
      this.renderLibrary();
    }
  };

  App.prototype.showLibrary = function () {
    this.libView.hidden = false;
    this.detailView.hidden = true;
  };

  App.prototype.showDetail = function () {
    this.libView.hidden = true;
    this.detailView.hidden = false;
    window.scrollTo(0, 0);
  };

  App.prototype.bindEvents = function () {
    var self = this;
    var searchInput = this.root.querySelector('[data-tcb-pc-package-search]');
    var searchBtn = this.root.querySelector('[data-tcb-pc-search-btn]');

    if (searchBtn) searchBtn.addEventListener('click', function () { self.runPackageSearch(searchInput.value); });
    if (searchInput) searchInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') self.runPackageSearch(searchInput.value); });

    this.root.querySelectorAll('[data-tcb-pc-filter]').forEach(function (group) {
      var key = group.getAttribute('data-tcb-pc-filter');
      group.querySelectorAll('.tcb-ec-chip').forEach(function (chip) {
        chip.addEventListener('click', function () {
          var val = chip.getAttribute('data-value');
          var active = chip.classList.toggle('is-active');
          self.filters[key] = active ? val : '';
        });
      });
    });

    var showMatches = this.root.querySelector('[data-tcb-pc-show-matches]');
    if (showMatches) showMatches.addEventListener('click', function () {
      self.renderLibrary();
      var el = document.getElementById('tcb-pc-start');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    });

    var catFilter = this.root.querySelector('[data-tcb-pc-cat-filter]');
    var facilityFilter = this.root.querySelector('[data-tcb-pc-facility-filter]');
    var libSort = this.root.querySelector('[data-tcb-pc-lib-sort]');
    if (catFilter) catFilter.addEventListener('change', function () { self.renderLibrary(); });
    if (facilityFilter) facilityFilter.addEventListener('change', function () { self.renderLibrary(); });
    if (libSort) libSort.addEventListener('change', function () { self.renderLibrary(); });

    var libReset = this.root.querySelector('[data-tcb-pc-lib-reset]');
    if (libReset) libReset.addEventListener('click', function () {
      if (catFilter) catFilter.value = '';
      if (facilityFilter) facilityFilter.value = '';
      if (libSort) libSort.value = 'popular';
      self.filters = { facility: '', tier: '', category: '' };
      self.root.querySelectorAll('.tcb-ec-chip.is-active').forEach(function (c) { c.classList.remove('is-active'); });
      self.renderLibrary();
    });

    var stickyGo = this.root.querySelector('[data-tcb-pc-sticky-go]');
    var stickyClear = this.root.querySelector('[data-tcb-pc-sticky-clear]');
    if (stickyGo) stickyGo.addEventListener('click', function () {
      var list = getCompareList();
      if (list.length >= 2) window.location.href = compareUrl(list);
    });
    if (stickyClear) stickyClear.addEventListener('click', function () {
      setCompareList([]);
      self.updateSticky();
    });

    window.addEventListener('popstate', function () {
      var p = new URLSearchParams(window.location.search);
      if (p.get('compare') || p.get('custom')) return;
      self.showLibrary();
      self.renderLibrary();
    });
  };

  App.prototype.populateFilters = function () {
    var catSel = this.root.querySelector('[data-tcb-pc-cat-filter]');
    var facSel = this.root.querySelector('[data-tcb-pc-facility-filter]');
    if (catSel) {
      (this.catalog.categories || []).forEach(function (c) {
        var o = document.createElement('option');
        o.value = c.id;
        o.textContent = c.title;
        catSel.appendChild(o);
      });
    }
    if (facSel) {
      (this.catalog.facilities || []).forEach(function (f) {
        var o = document.createElement('option');
        o.value = f.id;
        o.textContent = f.shortTitle || f.title;
        facSel.appendChild(o);
      });
    }
  };

  App.prototype.renderCategories = function () {
    var host = this.root.querySelector('[data-tcb-pc-categories]');
    if (!host) return;
    host.innerHTML = (this.catalog.categories || []).map(function (c) {
      return '<a class="tcb-ec-cat-card tcb-ec-cat-card--thumb" href="' + detailUrl(c.id) + '">' +
        (c.hero_image ? '<span class="tcb-ec-cat-card__media">' + imgTag(c.hero_image, c.title) + '</span>' : '') +
        '<strong>' + esc(c.title) + '</strong>' +
        '<span>' + (c.comparison_count || 0) + ' comparisons</span>' +
        '<span class="tcb-ec-cat-card__cta">Compare →</span></a>';
    }).join('');
  };

  App.prototype.renderFacilityTable = function () {
    var host = this.root.querySelector('[data-tcb-pc-type-table]');
    if (!host) return;
    var rows = (this.catalog.facilities || []).slice(0, 12).map(function (f) {
      return '<tr><td><a href="' + detailUrl(f.id + '-tier-ladder') + '">' + esc(f.title) + '</a></td>' +
        '<td>4 tiers</td>' +
        '<td><a href="' + f.url + '">View hub</a> · <a href="' + detailUrl(f.id + '-tier-ladder') + '">Compare</a></td></tr>';
    }).join('');
    host.innerHTML = '<table class="tcb-ec-type-table"><thead><tr><th>Facility Type</th><th>Tiers</th><th>Actions</th></tr></thead><tbody>' + rows + '</tbody></table>';
  };

  App.prototype.renderFacilities = function () {
    var host = this.root.querySelector('[data-tcb-pc-facilities]');
    if (!host) return;
    host.innerHTML = (this.catalog.facilities || []).slice(0, 8).map(function (f) {
      var hero = f.hero_image ? ' style="background-image:url(\'' + esc(f.hero_image) + '\')"' : '';
      return '<a class="tcb-ec-industry tcb-ec-industry--thumb" href="' + (f.compare_url || detailUrl(f.id + '-tier-ladder')) + '">' +
        (f.hero_image ? '<span class="tcb-ec-industry__bg"' + hero + ' aria-hidden="true"></span>' : '') +
        '<strong>' + esc(f.shortTitle || f.title) + '</strong><span>Compare tiers →</span></a>';
    }).join('');
  };

  App.prototype.renderEquipmentLink = function () {
    var host = this.root.querySelector('[data-tcb-pc-equipment]');
    if (!host) return;
    var url = this.catalog.equipment_compare_url || '/pages/equipment-comparison';
    host.innerHTML = '<a class="tcb-ec-package-card" href="' + url + '"><strong>Compare Individual Machines</strong><span>Equipment Comparison →</span></a>';
  };

  App.prototype.renderRelated = function () {
    var host = this.root.querySelector('[data-tcb-pc-related]');
    if (!host || !this.catalog.related_guides) return;
    host.innerHTML = this.catalog.related_guides.map(function (g) {
      return '<a href="' + g.url + '">' + esc(g.title) + ' →</a>';
    }).join('');
  };

  App.prototype.renderPopularSearches = function () {
    var host = this.root.querySelector('[data-tcb-pc-popular]');
    if (!host) return;
    var popular = (this.catalog.comparisons || []).filter(function (c) { return c.popular; }).slice(0, 6);
    host.innerHTML = '<span class="tcb-ec-popular__label">Popular:</span>' + popular.map(function (c) {
      return '<a href="' + detailUrl(c.id) + '">' + esc(c.label) + '</a>';
    }).join('');
  };

  App.prototype.runPackageSearch = function (q) {
    var host = this.root.querySelector('[data-tcb-pc-search-results]');
    if (!host) return;
    q = (q || '').toLowerCase().trim();
    if (!q) { host.hidden = true; return; }
    var hits = (this.catalog.packages_index || []).filter(function (p) {
      return p.search.indexOf(q) !== -1;
    }).slice(0, 12);
    if (!hits.length) {
      host.innerHTML = '<p>No packages found. Try a facility type or tier.</p>';
      host.hidden = false;
      return;
    }
    var self = this;
    host.innerHTML = hits.map(function (p) {
      return '<div class="tcb-ec-search-hit">' +
        (p.image ? imgTag(p.image, p.title) : '') +
        '<div><strong>' + esc(p.title) + '</strong><span>' + esc(priceText(p)) + '</span></div>' +
        '<button type="button" class="tcb-rh-btn tcb-rh-btn--outline" data-add="' + esc(p.handle) + '">+ Compare</button>' +
        '<a href="' + esc(p.url) + '">View</a></div>';
    }).join('');
    host.hidden = false;
    host.querySelectorAll('[data-add]').forEach(function (btn) {
      btn.addEventListener('click', function () { self.addToCompare(btn.getAttribute('data-add')); });
    });
  };

  App.prototype.addToCompare = function (handle) {
    var list = getCompareList();
    if (list.indexOf(handle) === -1) list.push(handle);
    setCompareList(list);
    this.updateSticky();
  };

  App.prototype.updateSticky = function () {
    var bar = this.root.querySelector('[data-tcb-pc-sticky]');
    var items = this.root.querySelector('[data-tcb-pc-sticky-items]');
    var list = getCompareList();
    if (!bar || !items) return;
    if (list.length < 1) { bar.hidden = true; return; }
    bar.hidden = false;
    var idx = this.catalog.packages_index || [];
    items.innerHTML = list.map(function (h) {
      var p = idx.find(function (x) { return x.handle === h; });
      return '<span class="tcb-ec-sticky__item">' + esc(p ? p.title.slice(0, 30) : h) + '</span>';
    }).join('') + '<span class="tcb-ec-sticky__count">' + list.length + '/' + MAX_COMPARE + '</span>';
    var go = this.root.querySelector('[data-tcb-pc-sticky-go]');
    if (go) go.disabled = list.length < 2;
  };

  App.prototype.renderLibrary = function (keepPage) {
    var self = this;
    var grid = this.root.querySelector('[data-tcb-pc-library-grid]');
    var status = this.root.querySelector('[data-tcb-pc-lib-status]');
    var pagination = this.root.querySelector('[data-tcb-pc-library-pagination]');
    var catFilter = this.root.querySelector('[data-tcb-pc-cat-filter]');
    var facilityFilter = this.root.querySelector('[data-tcb-pc-facility-filter]');
    var sort = this.root.querySelector('[data-tcb-pc-lib-sort]');
    if (!grid) return;
    if (!keepPage) this.libPage = 0;

    var items = (this.catalog.comparisons || []).slice();
    var cat = catFilter ? catFilter.value : '';
    var facility = facilityFilter ? facilityFilter.value : '';
    var sortVal = sort ? sort.value : 'popular';

    if (cat) items = items.filter(function (c) { return c.category === cat || c.id === cat || c.id.indexOf(cat) !== -1; });
    if (facility) {
      items = items.filter(function (c) {
        return c.id.indexOf(facility) !== -1 || (c.packages || []).some(function (h) {
          var p = catalogRecord(this.catalog, h);
          return p && p.facilityId === facility;
        }, this);
      }.bind(this));
    }
    if (this.filters.category) items = items.filter(function (c) { return c.category === this.filters.category; }.bind(this));
    if (this.filters.tier) {
      items = items.filter(function (c) {
        return (c.packages || []).some(function (h) {
          var p = catalogRecord(this.catalog, h);
          return p && p.tier === this.filters.tier;
        }, this);
      }.bind(this));
    }
    if (this.filters.facility || this.filters.tier || this.filters.category || this.filters.budget) {
      items = items.filter(function (c) {
        return matchesPackageFilters(c, this.filters, this.catalog);
      }.bind(this));
    }

    if (sortVal === 'alpha') items.sort(function (a, b) { return a.label.localeCompare(b.label); });
    else if (sortVal === 'products') items.sort(function (a, b) { return (b.packages?.length || 0) - (a.packages?.length || 0); });
    else items.sort(function (a, b) { return (b.popular ? 1 : 0) - (a.popular ? 1 : 0); });

    var totalPages = Math.max(1, Math.ceil(items.length / LIB_PAGE_SIZE));
    if (this.libPage >= totalPages) this.libPage = totalPages - 1;
    if (this.libPage < 0) this.libPage = 0;
    var start = this.libPage * LIB_PAGE_SIZE;
    var pageItems = items.slice(start, start + LIB_PAGE_SIZE);

    if (status) {
      if (!items.length) status.textContent = 'No comparisons match your filters.';
      else if (totalPages <= 1) status.textContent = items.length + ' comparisons available';
      else status.textContent = items.length + ' comparisons · showing ' + (start + 1) + '–' + Math.min(start + LIB_PAGE_SIZE, items.length);
    }

    grid.innerHTML = pageItems.map(function (c) {
      var badge = c.popular ? '<span class="tcb-ec-lib-badge">Popular</span>' : '';
      var hero = c.hero_image || comparisonHero(c, self.catalog);
      return '<article class="tcb-ec-lib-card tcb-ec-lib-card--thumb">' + badge +
        (hero ? '<div class="tcb-ec-lib-card__media">' + imgTag(hero, c.label) + '</div>' : '') +
        '<h3><a href="' + detailUrl(c.id) + '">' + esc(c.label) + '</a></h3>' +
        '<p class="tcb-ec-lib-card__sub">' + esc(c.subtitle || '') + '</p>' +
        '<p>' + esc(c.summary || '') + '</p>' +
        '<p class="tcb-ec-lib-card__meta">' + (c.packages?.length || 0) + ' packages</p>' +
        '<a class="tcb-rh-btn tcb-rh-btn--blue" href="' + detailUrl(c.id) + '">View Comparison</a></article>';
    }).join('');

    renderLibraryPagination(pagination, this.libPage, totalPages, function (nextPage) {
      self.libPage = nextPage;
      self.renderLibrary(true);
      if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  };

  App.prototype.openDetail = function (id) {
    var comparison = (this.catalog.comparisons || []).find(function (c) { return c.id === id; });
    if (!comparison) {
      var cat = (this.catalog.categories || []).find(function (c) { return c.id === id; });
      if (cat) {
        this.showLibrary();
        var catFilter = this.root.querySelector('[data-tcb-pc-cat-filter]');
        if (catFilter) catFilter.value = id;
        this.renderLibrary();
        var lib = document.getElementById('tcb-pc-start');
        if (lib) lib.scrollIntoView({ behavior: 'smooth' });
        history.replaceState({}, '', detailUrl(id));
        return;
      }
      this.showLibrary();
      return;
    }
    this.showDetail();
    this.renderDetail(comparison);
    history.replaceState({}, '', detailUrl(id));
  };

  App.prototype.openCustomCompare = function (handles) {
    var comparison = {
      id: 'custom',
      label: 'Your Package Comparison',
      subtitle: 'Custom side-by-side comparison',
      packages: handles.slice(0, MAX_COMPARE),
      tiers: handles.map(function (_, i, arr) {
        if (arr.length <= 1) return 'GOOD';
        if (i === 0) return 'GOOD';
        if (i === arr.length - 1) return 'BEST';
        return 'BETTER';
      }),
      rows: buildRowsFromHandles(handles.slice(0, MAX_COMPARE), this.catalog),
      best_for: handles.map(function (h) {
        var rec = catalogRecord(this.catalog, h);
        return rec ? rec.bestFor : 'Matched to your compare list.';
      }, this),
    };
    this.showDetail();
    this.renderDetail(comparison);
  };

  App.prototype.renderDetail = function (comparison) {
    var self = this;
    var handles = comparison.packages || [];
    var title = this.root.querySelector('[data-tcb-pc-detail-title]');
    var sub = this.root.querySelector('[data-tcb-pc-detail-sub]');
    var crumb = this.root.querySelector('[data-tcb-pc-detail-crumb]');
    var status = this.root.querySelector('[data-tcb-pc-detail-status]');
    var prodHost = this.root.querySelector('[data-tcb-pc-detail-packages]');
    var tableHost = this.root.querySelector('[data-tcb-pc-detail-table]');
    var recHost = this.root.querySelector('[data-tcb-pc-detail-recommend]');
    var keyHost = this.root.querySelector('[data-tcb-pc-detail-keydiff]');
    var popHost = this.root.querySelector('[data-tcb-pc-detail-popular]');
    var introHost = this.root.querySelector('[data-tcb-pc-detail-intro]');
    var heroHost = this.root.querySelector('[data-tcb-pc-detail-hero]');

    if (title) title.textContent = comparison.label;
    if (sub) {
      var subText = comparison.subtitle || '';
      var redundant = !subText ||
        subText.toLowerCase() === (comparison.label || '').toLowerCase() ||
        (comparison.label || '').toLowerCase().indexOf(subText.toLowerCase()) !== -1 ||
        subText.indexOf('→') !== -1;
      sub.textContent = redundant ? '' : subText;
      sub.hidden = redundant;
    }
    if (crumb) crumb.textContent = comparison.label;
    renderTierStrip(this.root.querySelector('[data-tcb-pc-detail-tierstrip]'), comparison.subtitle);
    if (introHost) {
      introHost.innerHTML = '';
      introHost.hidden = true;
    }
    if (heroHost) {
      var hero = comparisonHero(comparison, self.catalog);
      if (hero) {
        heroHost.innerHTML = imgTag(hero, comparison.label);
        heroHost.hidden = false;
      } else {
        heroHost.innerHTML = '';
        heroHost.hidden = true;
      }
    }

    var entries = handles.map(function (handle) {
      return { handle: handle, rec: catalogRecord(self.catalog, handle) };
    }).filter(function (e) { return e.rec; });

    if (!entries.length) {
      if (status) status.textContent = 'Packages not found. Try another comparison.';
      return;
    }
    if (status) status.textContent = '';

    if (introHost) {
      var intro = 'Comparing <strong>' + entries.length + ' packages</strong>';
      if (comparison.summary) intro += ' — ' + esc(comparison.summary);
      introHost.innerHTML = intro;
      introHost.hidden = false;
    }

    var tiers = comparison.tiers || entries.map(function (_, i) {
      if (i === 0) return 'GOOD';
      if (i === entries.length - 1) return 'BEST';
      return 'BETTER';
    });

    if (prodHost) {
      var rowClass = 'tcb-ec-prod-row tcb-ec-prod-row--' + Math.min(entries.length, 4);
      prodHost.innerHTML = '<div class="' + rowClass + '">' + entries.map(function (entry, i) {
        var rec = entry.rec;
        var tier = tiers[i] || 'GOOD';
        var tierCls = tierClassName(tier, rec);
        var cartBtn = rec.cart_items && rec.cart_items.length
          ? '<button type="button" class="tcb-rh-btn tcb-rh-btn--cart tcb-ec-cart-btn" data-package-handle="' + esc(entry.handle) + '">Add Package to Cart</button>'
          : '';
        return '<div class="tcb-ec-prod-card tcb-ec-prod-card--' + tierCls + '">' +
          '<span class="tcb-ec-tier tcb-ec-tier--' + tierCls + '">' + esc(rec.badge || tier) + '</span>' +
          (rec.image ? imgTag(rec.image, rec.title) : '') +
          '<h3><a href="' + esc(rec.url) + '">' + esc(rec.title) + '</a></h3>' +
          (rec.badge ? '<div class="tcb-ec-prod-card__rating"><span class="tcb-ec-review-count">' + esc(rec.badge) + ' tier</span></div>' : '') +
          '<div class="tcb-ec-price">' + esc(priceText(rec)) + '</div>' +
          (cartBtn ? '<div class="tcb-ec-prod-card__actions">' + cartBtn + '</div>' : '') +
          '<a class="tcb-rh-btn tcb-rh-btn--outline" href="' + esc(rec.url) + '">View Package</a>' +
          '<a class="tcb-rh-btn tcb-rh-btn--blue" href="' + (urls.quote || '/pages/contact') + '">Request Quote</a></div>';
      }).join('') + '</div>';
      prodHost.querySelectorAll('[data-package-handle]').forEach(function (btn) {
        bindPackageCartButton(btn, self.catalog);
      });
    }

    var rows = comparison.rows || buildRowsFromHandles(handles, self.catalog);
    var tableHtml = '<table class="tcb-ec-table"><thead><tr><th>Specification</th>';
    entries.forEach(function (entry, i) {
      tableHtml += '<th>' + esc(entry.rec.title.slice(0, 40)) + ' <span class="tcb-ec-tier tcb-ec-tier--' + (tiers[i] || 'good').toLowerCase() + '">' + esc(tiers[i] || '') + '</span></th>';
    });
    tableHtml += '</tr></thead><tbody>';
    rows.forEach(function (row) {
      tableHtml += '<tr><th scope="row" class="tcb-ec-row-label">' + esc(row.label) + '</th>';
      entries.forEach(function (entry) {
        tableHtml += '<td>' + esc(fieldValue(entry.handle, row, self.catalog)) + '</td>';
      });
      tableHtml += '</tr>';
    });
    tableHtml += '<tr><th scope="row" class="tcb-ec-row-label">TCB Recommendation</th>';
    entries.forEach(function (entry, i) {
      var rec = packageRecommendation(entry.rec, comparison, i);
      tableHtml += '<td>' + esc(rec) + '</td>';
    });
    tableHtml += '</tbody></table>';
    if (tableHost) {
      tableHost.innerHTML = tableHtml;
      tableHost.hidden = false;
      markUniformTableRows(tableHost);
      bindDiffToggle(self.root, '[data-tcb-pc-diff-toggle]', '[data-tcb-pc-detail-table]');
    }

    if (recHost) {
      recHost.innerHTML = '<h2>Our Recommendation</h2><div class="tcb-ec-best-grid">' + entries.map(function (entry, i) {
        return '<div class="tcb-ec-card"><span class="tcb-ec-tier tcb-ec-tier--' + (tiers[i] || 'good').toLowerCase() + '">' + esc(tiers[i] || 'PICK') + '</span>' +
          '<strong>Choose ' + esc(entry.rec.shortTitle.slice(0, 40)) + ' if:</strong>' +
          '<p>' + esc(packageRecommendation(entry.rec, comparison, i)) + '</p></div>';
      }).join('') + '</div>';
      recHost.hidden = false;
    }

    if (keyHost) {
      var specKeys = ['main_machine', 'zones_covered', 'chemicals', 'parts', 'facility_size'];
      var keys = specKeys.filter(function (k) {
        return entries.some(function (e) { return e.rec.specs && e.rec.specs[k]; });
      }).slice(0, 6);
      var keyHtml = keys.map(function (k) {
        var label = k.replace(/_/g, ' ');
        var vals = entries.map(function (e) {
          return (e.rec.specs && e.rec.specs[k]) || '—';
        }).join(' · ');
        return '<div class="tcb-ec-key"><strong>' + esc(label) + '</strong><p>' + esc(vals) + '</p></div>';
      }).join('');
      keyHost.innerHTML = '<h2>Key Differences That Matter</h2><div class="tcb-ec-key-grid">' + keyHtml +
        '<div class="tcb-ec-key"><strong>Price</strong><p>' + entries.map(function (e) {
          return priceText(e.rec);
        }).join(' · ') + '</p></div></div>';
      keyHost.hidden = false;
    }

    if (popHost) {
      var others = (self.catalog.comparisons || []).filter(function (c) { return c.id !== comparison.id && c.popular; }).slice(0, 4);
      popHost.innerHTML = '<h3>Popular Comparisons</h3><div class="tcb-ec-side-popular">' + others.map(function (c) {
        return '<a href="' + detailUrl(c.id) + '">' + esc(c.label) + ' →</a>';
      }).join('') + '</div>';
    }
  };

  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('[data-tcb-package-comparison]');
    if (!root || !window.TCB_PKG_COMPARE_DATA_URL) return;
    fetch(window.TCB_PKG_COMPARE_DATA_URL)
      .then(function (r) { return r.json(); })
      .then(function (catalog) { new App(root, catalog); })
      .catch(function () {
        var s = root.querySelector('[data-tcb-pc-lib-status]');
        if (s) s.textContent = 'Unable to load package comparison library.';
      });
  });
})();
